import FaceValidationReleaseSettings from './FaceValidationReleaseSettings';
import FiscalChatVisibility from './FiscalChatVisibility';
import React from "react";
import { Form, FormControl as Input, InputGroup } from "react-bootstrap";
import { FormControlLabel, Radio } from "@material-ui/core";
import { RadioGroup } from "@mui/material";
import Attention from "../ReusableComponents/Attention";

const BoolOptions = ({ value, onChange, disabled = false }) => (
    <RadioGroup value={value}>
        <FormControlLabel disabled={disabled} onClick={() => !disabled && onChange(true)} control={<Radio checked={value == true} value={true} />} style={{ color: "black" }} label="Sim" />
        <FormControlLabel disabled={disabled} onClick={() => !disabled && onChange(false)} control={<Radio checked={value == false} value={false} />} style={{ color: "black" }} label="Não" />
    </RadioGroup>
);

const Field = ({ label, description, children, required = true, className = "" }) => (
    <div className={`flex fdcolumn flex1 margin-bottom processo-config-field ${className}`}>
        <Form.Label>{label} {required && <Attention />}</Form.Label>
        {description && <small>{description}</small>}
        {children}
    </div>
);

const ProcessoConfigFields = ({ state, setState, empresa, children, restrictAccessFields = null }) => {
    const update = patch => {
        const next = { ...state, ...patch };
        if ((next.need_pause || next.required_camera_external) && next.chat_type === 'none') next.chat_type = 'all';
        setState(next);
    };
    const onlineEnabled = empresa?.online_proccess !== false && state.online == true;

    const fiscalizacoes = state.simulado == true
        ? [
            { id: "all", name: "Testar compartilhamento de câmera e áudio" },
            { id: "none", name: "Não compartilhar câmera e áudio" },
        ]
        : [
            { id: "all", name: "Salvar Vídeo e Imagem - Com streaming em tempo real" },
            { id: "image", name: "Salvar Apenas Imagem - Com streaming em tempo real" },
            { id: "none", name: "Salvar apenas logs - Sem streaming" },
        ];

    const chatTypes = [
        { id: "all", name: "Ambos enviam mensagem" },
        { id: "fiscal_to_student", name: "Apenas o fiscal envia mensagem" },
        { id: "none", name: "Ninguem envia mensagem" },
    ];

    return (
        <div className="processo-config-shared">
            {empresa?.online_proccess !== false && <InputGroup className="processo-config-grid one">
                <Field label="A avaliação é online?">
                    <BoolOptions value={state.online} onChange={value => update({ online: value })} />
                </Field>
            </InputGroup>}

            {onlineEnabled && <InputGroup className="processo-config-grid one">
                <Field label="É um avaliação oral?" description="Se habilitado, esta vaga/cargo será uma entrevista (avaliação oral) com os candidatos vinculados a ele, onde será possível cadastrar os critérios de avaliação e quem serão os avaliadores. Cada avaliador poderá entrar em chamadas individuais com cada candidato.">
                    <BoolOptions value={state.is_interview} onChange={value => update({ is_interview: value })} />
                </Field>
            </InputGroup>}

            {children}

            {onlineEnabled && <>
                <InputGroup className="processo-config-grid one">
                    <Field label="É um simulado para teste de compatibilidade dos candidatos?" description="Se habilitado, essa vaga/cargo será um teste para os candidatos conseguirem acessar o sistema e testar funções como compartilhamento de câmera/áudio/tela. Será gerado também uma prova teste dentro da vaga/cargo.">
                        <BoolOptions
                            value={state.simulado}
                            onChange={value => update(value == true
                                ? { simulado: true, type_time: "restrict", tempo_prova: 4, fiscalizacao: "all", chat_type: "none", exam_per_time: false }
                                : { simulado: false, chat_type: "all", type_time: "all", tempo_prova: "" })}
                        />
                    </Field>
                </InputGroup>

                <InputGroup className="processo-config-grid two">
                    <Field label="Cada avaliação terá um tempo máximo para fazer?" description="Se habilitado, na hora de criar a prova será obrigatório definir o tempo, em minutos, que cada questão terá para ser respondida.">
                        <BoolOptions value={state.exam_per_time} disabled={state.simulado == true} onChange={value => update({ exam_per_time: value })} />
                    </Field>
                    <Field label="O candidato poderá solicitar pausa durante a prova?" description='Se habilitado, é exibilido um botão de "Pedir Pausa" do lado do candidato, onde ele poderá solicitar pausas durante a prova com uma justificativa, por exemplo: preciso ir ao banheiro, preciso amamentar, etc. O fiscal vinculado a sala daquele candidato deverá aceitar ou negar a pausa solicitada.'>
                        <BoolOptions value={state.need_pause} onChange={value => update({ need_pause: value })} />
                    </Field>
                </InputGroup>

                <InputGroup className="processo-config-grid two">
                    <Field label="O candidato poderá acessar por dispositivos móveis?" description="Se habilitado, a avaliação também poderá ser realizada por dispositivos móveis, porém algumas funções não poderão ser habilitadas, sendo estas: Gravação de tela e Validação facial.">
                        <BoolOptions
                            value={state.mobile}
                            onChange={value => update(value == true
                                ? { mobile: true, screen_sharing: false, required_camera_external: false, face_validation: false, face_validation_periodicaly: false }
                                : { mobile: false })}
                        />
                    </Field>
                    <Field label="Disponibilizar campo para rascunho em cada questão?" description="Se habilitado, em cada questão terá um botão de rascunho para o candidato, onde será aberto um caixa de texto para o candidato escrever. O rascunho não é salvo pelo sistema.">
                        <BoolOptions value={state.show_rascunho} onChange={value => update({ show_rascunho: value })} />
                    </Field>
                </InputGroup>

                <InputGroup className="processo-config-grid two">
                    <Field label="Obrigar o uso de tela cheia para ver a avaliação?" description="Se habilitado, o candidato só conseguirá fazer a avaliação com o sistema em tela cheia. Caso ele saia da tela cheia, o sistema registro como saída de tela.">
                        <BoolOptions value={state.full_screen} onChange={value => update({ full_screen: value })} />
                    </Field>
                    <Field label="Tempo de prova">
                        <RadioGroup value={state.type_time}>
                            <FormControlLabel disabled={state.simulado == true} onClick={() => state.simulado != true && update({ type_time: "all" })} control={<Radio checked={state.type_time == "all"} value="all" />} style={{ color: "black" }} label="Candidato pode usar o tempo total de prova" />
                            <FormControlLabel disabled={state.simulado == true} onClick={() => state.simulado != true && update({ type_time: "restrict" })} control={<Radio checked={state.type_time == "restrict"} value="restrict" />} style={{ color: "black" }} label="Candidato tem um tempo de prova restrito a partir do acesso" />
                        </RadioGroup>
                        {state.type_time == "restrict" && <>
                            <Form.Label className="mt-2">Tempo de prova em minutos <Attention /></Form.Label>
                            <Input type="number" min={1} disabled={state.simulado == true} placeholder="Tempo de prova em minutos que o candidato terá após o primeiro acesso" value={state.tempo_prova} onChange={event => update({ tempo_prova: event.target.value })} />
                        </>}
                    </Field>
                </InputGroup>

                {state.simulado == false && <InputGroup className="processo-config-grid one">
                    <Field label="Tipo de Fiscalização">
                        <select className="form-select" value={state.fiscalizacao} onChange={event => update({ fiscalizacao: event.target.value, chat_type: "all", face_validation: false, face_validation_periodicaly: false, screen_sharing: false, required_camera_external: false })}>
                            {fiscalizacoes.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                        </select>
                    </Field>
                </InputGroup>}

                {state.simulado == false && <InputGroup className="processo-config-grid one">
                    <Field label="Tipo de chat">
                        <FiscalChatVisibility value={state.show_fiscal_chat} onChange={value => update({ show_fiscal_chat: value })} />
                        <select className="form-select" value={state.chat_type} onChange={event => update({ chat_type: event.target.value })}>
                            {chatTypes.map(item => <option key={item.id} value={item.id} disabled={item.id === "none" && (state.need_pause || state.required_camera_external)}>{item.name}</option>)}
                        </select>
                    </Field>
                </InputGroup>}

                {state.fiscalizacao != "none" && <InputGroup className="processo-config-grid one">
                    <Field label="Tempo em minutos anterior à avaliação que deve aparecer para o candidato o chat de comunicação com o fiscal" description="Exemplo: Caso seja colocado 60 minutos, uma hora antes do início da avaliação aparecerá para o candidato o chat de comunicação onde é possível enviar e receber mensagens dos fiscais.">
                        <Input type="number" min={1} placeholder="Tempo em minutos" value={state.chat_time} onChange={event => update({ chat_time: event.target.value })} />
                    </Field>
                </InputGroup>}

                <InputGroup className="processo-config-grid two">
                    <Field label="Bloquear uso de duas ou mais telas extendidas?">
                        <BoolOptions value={state.screen_extended_retrict} disabled={state.screen_sharing == true} onChange={value => update({ screen_extended_retrict: value })} />
                    </Field>
                    {state.fiscalizacao == "all" && state.mobile == false && <Field label={state.simulado == true ? "Obrigar compartilhamento de tela para o teste? (Simula a gravação de tela para caso for usar em uma prova real)" : "Gravar a tela do candidato? (Exige compartilhamento de tela)"}>
                        <BoolOptions value={state.screen_sharing} disabled={state.mobile == true} onChange={value => update({ screen_sharing: value, screen_extended_retrict: value == true ? true : state.screen_extended_retrict })} />
                    </Field>}
                </InputGroup>

                {state.fiscalizacao == "all" && state.mobile == false && <InputGroup className="processo-config-grid two">
                    <Field label="Usar inteligência artificial para ter validação facial e microfone na entrada?" description="Se habilitada o candidato só conseguirá acessar a prova caso tenha sido identificado um rosto (apenas um) na imagem de sua câmera, e será necessário ele fazer movimentos para a esquerda e direita com a cabeça para validar sua entrada. Será necessário o candidato falar uma frase para ser validado o microfone.">
                        <BoolOptions value={state.face_validation} disabled={state.mobile == true} onChange={value => update({ face_validation: value, face_validation_periodicaly: value == false ? false : state.face_validation_periodicaly })} />
                    </Field>
                    <Field label="Obrigar câmera externa do candidato?" description="Se habilitada, o candidato só conseguirá visualizar e acessar a avaliação quando a câmera externa estiver conectada pelo celular.">
                        <BoolOptions value={state.required_camera_external} onChange={value => update({ required_camera_external: value })} />
                    </Field>
                </InputGroup>}

                {state.fiscalizacao == "all" && state.mobile == false && state.face_validation == true && <InputGroup className="processo-config-grid two">
                    <FaceValidationReleaseSettings allowContinue={state.allow_face_validation_skip}
                        onAllowContinue={value => update({ allow_face_validation_skip: value })}
                        minutes={state.request_time} onMinutesChange={value => update({ request_time: value })} chatType={state.chat_type} />
                    <Field label="Realizar validação facial e de microfone caso não detectado durante a avaliação?" description="Se habilitada, caso após o candidato acessar a avaliação não ser detecado um rosto na câmera ou oscilação de áudio no microfone por um determinado tempo, o candidato deverá realizar a validação novamente (Apenas se o candidato não tenha sido liberado pelo fiscal).">
                        <BoolOptions value={state.face_validation_periodicaly} disabled={state.mobile == true} onChange={value => update({ face_validation_periodicaly: value })} />
                        {state.face_validation_periodicaly == true && <>
                            <Form.Label className="mt-2">Tempo sem reconhecimento para o candidato ter que realizar a validação facial novamente (Em segundos) <Attention /></Form.Label>
                            <Input type="number" min={20} placeholder="Tempo em segundos" value={state.time_validation_periodicaly} onChange={event => update({ time_validation_periodicaly: event.target.value })} />
                        </>}
                    </Field>
                </InputGroup>}

                <InputGroup className="processo-config-grid one">
                    <Field label="Restringir horário de acesso do candidato?" description="Candidatos que não tiverem acessado o sistema dentro de um determinado horário, não conseguiram acessar a prova">
                        <BoolOptions value={state.restrict_access} onChange={value => update({ restrict_access: value })} />
                    </Field>
                </InputGroup>

                {state.restrict_access == true && <div className="processo-config-access-dates">
                    {restrictAccessFields}
                </div>}
            </>}

            <InputGroup className="processo-config-grid one">
                <Field label="O evento será dividido em blocos?" description="Caso sim, é possível definir o tempo de cada bloco, e um tempo de intervalo.">
                    <BoolOptions value={state.has_blocks} onChange={value => update({ has_blocks: value })} />
                </Field>
            </InputGroup>
        </div>
    );
};

export default ProcessoConfigFields;
